import React from 'react';
import { makeStyles } from '@material-ui/core';
import ButtonBase from '../../Buttons/ButtonBase';
import { Link as LinkScroll } from 'react-scroll';
import './FreemiumFuture.scss';

const useStyles = makeStyles({
    buttonStyle: {
        minWidth: 'inherit',
        width: 322,
    },
})

const FreemiumFuture = () => {

    const classes = useStyles()

    return ( 
        <section className="FreemiumFuture">
            <div className="FreemiumFuture_container">
                <div className="FreemiumFuture_containerText">
                    <p className="FreemiumFuture_containerText-title">
                        La era digital ha dado un salto sin precedentes 
                    </p>
                    <p className="FreemiumFuture_containerText-info">
                        Es momento de evolucionar, 
                        no se quede fuera de la 
                        transformación digital.
                    </p>
                    <LinkScroll
                        to="freemiumForm"
                        smooth="true"
                        duration={500}
                        offset={-60}
                        className={classes.linkScroll}
                    >
                        <ButtonBase
                            type="submit"
                            variant="secondary"
                            buttonStyle={classes.buttonStyle}
                        >
                            Conviértase en un abogado digital
                        </ButtonBase>
                    </LinkScroll>
                </div>
                <div className="FreemiumFuture_containerImg">
                    <img
                        className="FreemiumFuture_containerImg-img"
                        src='/img/freemiumMembershipLanding/Future/guy.png'
                        alt='guy'
                    />
                </div>
            </div>
        </section>
     );
}
 
export default FreemiumFuture;